import NextImage from 'next/image';

interface PropTypes {
  className?: string;
  priority?: boolean;
  sizes?: string;
}

function BrandLogo({
  className = 'h-[24px] w-[156px]',
  priority = false,
  sizes = '156px'
}: PropTypes) {
  return (
    <NextImage
      src="/assets/brand/trakio-logo.png"
      alt="Trakio"
      aria-label="Trakio"
      className={`object-contain ${className}`}
      width={462}
      height={71}
      priority={priority}
      sizes={sizes}
    />
  );
}

export default BrandLogo;
